const updateBoxscore = (state = {}, action) => {

    const {
        type = null,
        datasource,
        data = {}
    } = action;
    
    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const {
            liveData: {
                boxscore = {}
            } = {}
        } = data;
        return boxscore;
    }

    return state;
};

export default updateBoxscore;